import QuickorderHead from "components/Quickorder/QuickorderHead"
import QuickorderRow from "components/Quickorder/QuickorderRow"
import { Table } from "elemental-react16"
import PropTypes from "prop-types"
import React from "react"
import "./Quickorder.css"

export default function QuickorderTable( { products, handleRemoveProduct, onChange } ) {
  return (

    <div className="QuickorderTable" style={{ overflowX: "auto" }}>
      <Table>
        <QuickorderHead/>
        <ProductRowMapper products={products} handleRemove={handleRemoveProduct} onChange={onChange}/>
      </Table>
    </div>
  )
}

QuickorderTable.propTypes = {
  handleRemoveProduct: PropTypes.func.isRequired,
  products:            PropTypes.any,
}

const ProductRowMapper = ( { products, handleRemove, onChange } ) => {
  let output = []
  products.forEach( ( product ) => {
    output.push( <QuickorderRow
      key={product.article_nr}
      product={product}
      onChange={onChange}
      handleRemoveProduct={handleRemove}/> )
  } )

  return <tbody>{output}</tbody>
}



// WEBPACK FOOTER //
// ./src/components/Quickorder/QuickorderTable.js